import React, { useRef, useState, useEffect } from 'react';
import styles from '../camilanorvete/camilanorvete.module.scss';
import Perfil from './src/perfil.png';
import Link from '../../components/Link/link.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';

const Camilanorvete: React.FC = () => {

    return (
        <div className={styles.camilanorvete}>
            <div className={styles["body-thunder"]}>
                <div style={{ height: "250px" }} className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <img
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile Picture"
                    />
                    <h1>Dra. Camila Norvete</h1>
                    <p className="mb-0">Fisioterapeuta Dermatofuncional</p>
                    <p>Harmonização Facial</p>
                    <div className={styles.links}>
                        <Link
                            href="https://wa.me/5517996235161?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="Agendamentos"
                            icon={<WhatsappIcon height="40" color="#fff" />}
                            // image={Icon1}
                            backgroundColor="#9f7e15"
                            backgroundColorHover="#e0d672"
                            colorText="#fff"
                        />
                        <Link
                            href="https://www.instagram.com/camilanorvete?igsh=MWFkbmRjNXQzcXR6ZA=="
                            title="Instagram"
                            icon={<InstagramIcon height="32" color="#fff" />}
                            // image={Icon2}
                            backgroundColor="#9f7e15"
                            backgroundColorHover="#e0d672"
                            colorText="#fff"
                        />
                        <Link
                            href="https://maps.app.goo.gl/DdYSGcLUMJmnMRSa9"
                            title="Localização"
                            icon={<MapsIcon height="40" color="#fff" />}
                            // image={Icon3}
                            backgroundColor="#9f7e15"
                            backgroundColorHover="#e0d672"
                            colorText="#fff"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Camilanorvete;
